<script>
// import CryptoJS from 'crypto-js'

import { IseRecorder, Recorder_status } from '../../utils/ise-recorder/IseRecorder'

export default {
  name: 'IseRecorder',

  props: {
    appId: {
      type: String,
      required: true,
    },
    appSecret: {
      type: String,
      required: true,
    },
    appKey: {
      type: String,
      required: true,
    },
    text: String,
    ent: String,
    category: String,
    group: String,
    check_type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      recorder: null,
      recorderStatus: Recorder_status.NULL,
    }
  },

  computed: {
    scopedSlotProps() {
      return {
        status: this.recorderStatus,
        isRecorderInitFinish: this.isRecorderInitFinish,
        isRecording: this.isRecording,
      }
    },

    isRecorderInitFinish() {
      const { recorderStatus } = this
      return !!this.recorder && recorderStatus !== Recorder_status.INIT
    },

    isRecording() {
      return this.recorderStatus === Recorder_status.RECORDING || this.recorderStatus === Recorder_status.RECORD_END
    },
  },

  created() {
    this.recorder = new IseRecorder({
      appId: this.appId,
      appSecret: this.appSecret,
      appKey: this.appKey,
      onWillStatusChange: this.onWillStatusChange,
      onTextChange: this.onTextChange,
      onInvalidAudio: this.onInvalidAudio,
      getSID: this.getSID,
      $axios: this.$axios,
      logger: {
        log: (message, code) => {
          // if (code == '10114') {
          //   this.$emit('timeOut', message)
          // }
          this.$emit('getLog', {
            message,
            code,
          })
        },
        // info: (code) => {
        //   this.$emit('getInfo', code)
        // },
        error: (message, readyState, recorderState, messageDetail) => {
          this.$emit('getError', {
            message,
            readyState,
            recorderState,
            messageDetail,
          })
        },
        warn: (warn) => {
          this.$emit('getWarn', warn)
        },
      },
    })
    this.recorder.getWssUrl = this.getWssUrl
  },

  methods: {
    getRecorderBusinessParams() {
      return {
        ent: this.ent,
        category: this.category,
        text: this.text,
        group: this.group,
        check_type: this.check_type,
      }
    },

    handleClick() {
      this.toggleRecordStatus()
    },

    getIsRecording() {
      return this.isRecording
    },

    async startRecord() {
      if (!this.isRecorderInitFinish || this.isRecording) {
        return { success: false, message: '录音组件尚未就绪，请稍后重试' }
      }
      this.recorder.closeEventCode += '1'
      try {
        const started = await this.recorder.startRecord(this.getRecorderBusinessParams())
        return { success: started === true }
      } catch (error) {
        const errorMessage = error?.message || String(error)
        return { success: false, message: errorMessage }
      }
    },

    stopRecord() {
      if (this.isRecording) {
        this.recorder.closeEventCode += '2'
        return this.recorder.stopRecord()
      }
      console.log('Recorder_status', this.recorderStatus)
      return false
    },

    async toggleRecordStatus() {
      if (this.isRecording) {
        this.recorder.closeEventCode += '6'
        return this.recorder.stopRecord()
      } else if (this.isRecorderInitFinish) {
        this.recorder.closeEventCode += '7'
        return this.startRecord()
      }
      return false
    },
    async getWssUrl() {
      const { data } = await this.$axios.get('/tk/front/tongue/answer/wssurl', {
        params: {
          apiKey: this.appKey,
          apiSecret: this.appSecret,
        },
      })
      if (Number(data.status) !== 1 || !data.data) {
        throw new Error(data.message || '获取口语websocket连接地址失败')
      }
      return data.data
    },

    onWillStatusChange(oldStatus, status) {
      this.recorderStatus = status

      if (status === Recorder_status.RECORDING) {
        this.recorder.closeEventCode += '3'
        this.$emit('recording')
      } else if (status === Recorder_status.RECORD_END) {
        this.recorder.closeEventCode += '4'
        this.$emit('record-end', this.recorder.audioData)
      }
    },

    onTextChange(grade) {
      this.recorder.closeEventCode += '5'
      console.log('onTextChange')
      this.$emit('text-change', grade)
    },
    onInvalidAudio(message, detail) {
      this.$emit('record-invalid', { message, detail })
    },
    getSID(sid) {
      this.$emit('get-sid', sid)
    },
  },
  beforeDestroy() {
    // 页面重建时彻底释放旧实例，避免 iOS 微信继续占用已失效的麦克风会话。
    this.recorder?.destroy()
  },
}
</script>

<template>
  <div class="lc-recorder" @click="handleClick">
    <slot :isRecording="isRecording" :isRecorderInitFinish="isRecorderInitFinish"> </slot>
  </div>
</template>

<style lang="less" scoped></style>
